import axios from "axios";
import SessionAndStoreReset from '../../Components/SessionAndStoreReset/SessionAndStoreReset';
import { generateRandomString } from '../GenerateRandomString/GenerateRandomString';

export async function loginTimeOutAndRedirectHandler(apiCallFunction, dataForApiCall, dispatch, reduxDataSetter, navigater, navigaterPath, successResMessage, dataSubmittingLoader, redirectPath, setGotData="", isChangedByStageBar="") {

    apiCallFunction(dataForApiCall).then((responseDetailOfContact) => {
        if(responseDetailOfContact.data.message == "Login Time Out!") {
          (async function() {
            try {
              const logoutData = await axios.post(
                "https://salesforceb2b.customers.bigfivecrm.com/logout",
                {},
                { withCredentials: true }
              );
      
              SessionAndStoreReset(dispatch, reduxDataSetter, (data)=>{},navigater, navigaterPath);
            } catch (error) {
              console.error("Error during logout:", error);
            }
          })()
        }
        if(successResMessage != "") {
            if(responseDetailOfContact.data.message == successResMessage) {
                if(dataSubmittingLoader != "") {
                    dataSubmittingLoader(false);
                }
                if(redirectPath != "") {
                    if(isChangedByStageBar == "" || isChangedByStageBar == false) {
                      const newDataIdOfContact1 = generateRandomString()+"00JZ3"+responseDetailOfContact.data.id+generateRandomString();
                      const newDataIdOfContact2 = generateRandomString()+"00JZ3"+dataForApiCall.Id+generateRandomString();
                      sessionStorage.setItem("Pdsk21D34Rl98", true);
                      if(successResMessage == "Case detail created!") {
                        navigater(`/NewDataResult/Case/${newDataIdOfContact1}/Created/Case`); 
                      } else if(successResMessage == "Case detail updated!") {
                        navigater(`/NewDataResult/Case/${newDataIdOfContact2}/Updated/${dataForApiCall.CaseNumber}`); 
                      } else if(successResMessage == "Lead detail updated!") {
                        navigater(`/NewDataResult/Lead/${newDataIdOfContact2}/Updated/${dataForApiCall.Name}`); 
                      } else if(successResMessage == "Contact detail updated!") {
                        navigater(`/NewDataResult/Contact/${newDataIdOfContact2}/Updated/${dataForApiCall.Name}`); 
                      } else if(successResMessage == "Opportunity detail updated!") {
                        if(setGotData == true) {
                          window.location.reload();
                        } else {
                          navigater(`/NewDataResult/Opportunity/${newDataIdOfContact2}/Updated/${dataForApiCall.Name}`); 
                        }
                      } else {
                        sessionStorage.setItem("Pdsk21D34Rl98", false);
                        navigater(redirectPath); 
                      }
                    }
                }
                if(successResMessage != "Case detail created!" && successResMessage != "Case detail updated!" && successResMessage != "Lead detail updated!" && successResMessage != "Opportunity detail updated!" && successResMessage != "Contact detail updated!") {
                  window.location.reload();
                }
            }
        } else {
            dispatch(reduxDataSetter(responseDetailOfContact.data));
        setGotData(responseDetailOfContact.data.success);
        sessionStorage.setItem("GdEGeSTESGEt2ERgsdf34GEEr", "DGERJFA34gfyjXT");
        }
        
      }).catch((err) => {
        if(successResMessage == "") {
            sessionStorage.setItem("GdEGeSTESGEt2ERgsdf34GEEr", "sGsdkE34GseGHrSDX2F");
        }
        console.log(err);
      })

}

